import './segmentedButtonGroup.css';

interface SegmentedButtonProps {
    isActive?: boolean;
    children?: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

function SegmentedButton({ children, onClick, isActive = false }: SegmentedButtonProps) {
    const classes = [];
    if (isActive) classes.push('selected');

    return (
        <button type='button' className={classes.join(' ')} onClick={onClick}>
            {children}
        </button>
    );
}

interface Props<T extends Record<string, string>> {
    options: T;
    activeKey?: keyof T;
    onSetActive?: (key: keyof T) => void;
    variant?: 'rail' | 'tabs' | 'tabs-compact';
}

export default function SegmentedButtonGroup<T extends Record<string, string>>({
    options,
    activeKey,
    onSetActive,
    variant = 'rail',
}: Props<T>) {
    return (
        <div className={`segmented-button-group segmented-button-group--${variant}`}>
            {Object.entries(options).map(([key, label]) => (
                <SegmentedButton key={key} isActive={activeKey === key} onClick={() => onSetActive?.(key)}>
                    <SegmentedButtonLabel label={label} />
                </SegmentedButton>
            ))}
        </div>
    );
}

function SegmentedButtonLabel({ label }: { label: string }) {
    const match = /^(.*?)\s+\((.*?)\)$/.exec(label);

    if (!match) {
        return <span className='segmented-button-label'>{label}</span>;
    }

    return (
        <>
            <span className='segmented-button-label'>{match[1]}</span>
            <span className='segmented-button-count'>{match[2]}</span>
        </>
    );
}
